import { ChangeDetectorRef, NgZone, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({
  name: 'timeAgoTranslate',
  pure: false
})
export class TimeAgoTranslatePipe implements PipeTransform, OnDestroy {
  private timer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private ngZone: NgZone,
    private translocoService: TranslocoService
  ) {}

  transform(value: string | Date): string {
    this.removeTimer();

    const d = new Date(value);
    const now = new Date();
    const seconds = Math.round(Math.abs((+now - +d) / 1000));
    const timeToUpdate = this.getSecondsUntilUpdate(seconds);
    this.timer = this.ngZone.runOutsideAngular(() =>
      setTimeout(() => {
        this.ngZone.run(() => this.changeDetectorRef.markForCheck());
      }, timeToUpdate * 1000)
    );

    const minutes = Math.round(seconds / 60);
    const hours = Math.round(minutes / 60);
    const days = Math.round(hours / 24);
    const months = Math.round(days / 30.416);
    const years = Math.round(days / 365);

    if (seconds <= 45) return this.translocoService.translate('timeago.justNow');
    if (seconds <= 90) return this.translocoService.translate('timeago.minuteAgo');
    if (minutes <= 45)
      return this.translocoService.translate('timeago.minutesAgo', { count: minutes });
    if (minutes <= 90) return this.translocoService.translate('timeago.hourAgo');
    if (hours <= 22) return this.translocoService.translate('timeago.hoursAgo', { count: hours });
    if (hours <= 36) return this.translocoService.translate('timeago.dayAgo');
    if (days <= 25) return this.translocoService.translate('timeago.daysAgo', { count: days });
    if (days <= 45) return this.translocoService.translate('timeago.monthAgo');
    if (days <= 345) return this.translocoService.translate('timeago.monthsAgo', { count: months });
    if (days <= 545) return this.translocoService.translate('timeago.yearAgo');
    return this.translocoService.translate('timeago.yearsAgo', { count: years });
  }

  ngOnDestroy(): void {
    this.removeTimer();
  }

  private removeTimer(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  private getSecondsUntilUpdate(seconds: number): number {
    const min = 60;
    const hr = min * 60;
    const day = hr * 24;

    if (seconds < min) return 2;
    if (seconds < hr) return 30;
    if (seconds < day) return 300;
    return 3600;
  }
}
